export const TYPES = {	
	FETCH_ALL_BILL_TO_PARTIES_PENDING: 'FETCH_ALL_BILL_TO_PARTIES_PENDING',
	FETCH_ALL_BILL_TO_PARTIES_PARTIAL_SUCCESS: 'FETCH_ALL_BILL_TO_PARTIES_PARTIAL_SUCCESS',
	FETCH_ALL_BILL_TO_PARTIES_SUCCESS: 'FETCH_ALL_BILL_TO_PARTIES_SUCCESS',
	FETCH_ALL_BILL_TO_PARTIES_ERROR: 'FETCH_ALL_BILL_TO_PARTIES_ERROR',
	RESET_ALL_BILL_TO_PARTIES_ERROR: 'RESET_ALL_BILL_TO_PARTIES_ERROR',
}